// @ts-ignore
import BlockContent from '@sanity/block-content-to-react';
import { serializers } from './serializers';

export function SaneBlockChakra({ blocks }: any) {
  return <BlockContent blocks={blocks} serializers={serializers} />;
}
